export const ETHNICITY_MAP: Record<string, { ethnicity: string; race: string }> = {
  'american indian or alaska native': { ethnicity: '', race: 'American Indian or Alaska Native' },
  'african american or black': { ethnicity: '', race: 'African American or Black' },
  asian: { ethnicity: '', race: 'Asian' },
  'caucasian or white': { ethnicity: '', race: 'Caucasian or White' },
  'hispanic or latino': { ethnicity: 'Hispanic or Latino', race: '' },
  'middle eastern or north african': { ethnicity: '', race: 'Middle Eastern or North African' },
  'native hawaiian or other pacific islander': {
    ethnicity: '',
    race: 'Native Hawaiian or Other Pacific Islander',
  },
  'prefer not to disclose': { ethnicity: 'Not Reported', race: 'Not Reported' },
};

export const mapEnrollmentEthnicity = (
  raw: string | undefined
): { ethnicity: string; race: string } => {
  if (!raw || raw.trim() === '' || raw === '-') return { ethnicity: '-', race: '-' };

  const values = raw
    .split(',')
    .map((v) => v.trim().toLowerCase())
    .filter(Boolean);

  if (values.length === 0) return { ethnicity: '-', race: '-' };

  if (values.length === 1) {
    const mapped = ETHNICITY_MAP[values[0]];
    return mapped
      ? {
          ethnicity: mapped.ethnicity || '-',
          race: mapped.race || '-',
        }
      : { ethnicity: '-', race: '-' };
  }

  const hasHispanic = values.includes('hispanic or latino');
  const nonHispanicValues = values.filter((v) => v !== 'hispanic or latino');

  let race: string;
  if (nonHispanicValues.length === 0) {
    race = '-';
  } else if (nonHispanicValues.length === 1) {
    const mapped = ETHNICITY_MAP[nonHispanicValues[0]];
    race = mapped?.race || 'Multiracial';
  } else {
    race = 'Multiracial';
  }

  const ethnicity = hasHispanic ? 'Hispanic or Latino' : '-';

  return {
    ethnicity: ethnicity || '-',
    race: race || '-',
  };
};
